module.exports = __webpack_public_path__ + "static/media/ice.18341568.jpeg";